import React from 'react'
import { Helmet } from 'react-helmet'

import '../../css/Blog.css'

import SchoolFeedingProgram from '../../assets/img/school-feeding-program.jpg'

export default function FeedingProgram() {
  return (
    <div id="article">
      <Helmet>
        <title>EHDO launched a School Feeding Program - Enoho Fikir</title>
      </Helmet>

      <h1>EHDO launched a School Feeding Program</h1>
      <img src={ SchoolFeedingProgram } />
      <p>EHDO launched its first project in two public primary schools by embarking on a school feeding program. The two schools namely Adwa Ber and Wotatoch Genet are located in Yeka subcity, woreda 7 and 8 respectively. Children coming from economically disadvantaged families are provided with breakfast and lunch that is prepared in the school, organized and funded by Eneho Fikir. Parents living in the midst of poverty often find it challenging to send their children to school with adequate meals. Hence, this highly affects the physical and psychological wellbeing of the children. It is likely that children are forced to engage in labor work outside of the school hours to earn an income and support themselves or their family. In the worst face of poverty, situations lead them to drop out of school o end up being street kids. So far many students have been supported by EHDO so as to enable them to pursue their education without being affected negatively by the low economic status of their parents. EHDO believes that the long term results of this endeavor will be manifested through minimized number of street children and kids affected by poverty.</p>
    </div>
  )
}